import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VInput } from 'vuetify/lib/components/VInput';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.modeExplanation')))])]), _c(VDataTable, {
    attrs: {
      "items": _vm.twinCopiesData,
      "footer-props": _vm.tableFooterProps,
      "hide-default-header": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('span')];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (props) {
        return [_c('core-n20Card', {
          class: `dt-card-text-01 my-3`,
          attrs: {
            "border": `1px solid ${_vm.errornousParentId === props.item.parentId ? 'red' : 'transparent'}`
          }
        }, [_c(VRow, [_vm.errornousParentId === props.item.parentId ? _c(VCol, {
          staticClass: "mt-0 pt-0 pt-2 danger--text",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.noPermissionsOnParent')) + "\n          ")]) : _vm._e(), _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c(VTextField, {
          attrs: {
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
            "placeholder": _vm.titlePlaceholder,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "hide-details": "auto",
            "clearable": ""
          },
          model: {
            value: props.item.title,
            callback: function ($$v) {
              _vm.$set(props.item, "title", $$v);
            },
            expression: "props.item.title"
          }
        })], 1), _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_vm.globalParentId === false ? [_c('core-dtwin-finder', {
          ref: `twin-finder-${props.item.id}`,
          attrs: {
            "required": _vm.globalParentId === false,
            "objectFilter": _vm.twinParentFilter,
            "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
            "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
            "tenantId": _vm.orgTwin.tenantId,
            "sameTenant": "",
            "hideDetails": ""
          },
          model: {
            value: props.item.parentId,
            callback: function ($$v) {
              _vm.$set(props.item, "parentId", $$v);
            },
            expression: "props.item.parentId"
          }
        })] : [_c(VTextField, {
          attrs: {
            "value": `${_vm.globalParentTwin.title} (ID: ${_vm.globalParentTwin.id})`,
            "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
            "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "hide-details": "",
            "disabled": "",
            "readonly": ""
          }
        })]], 2), _vm.metaInfoToggles['tags'] ? _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('core-tags', {
          attrs: {
            "tags": _vm.get(props, 'item.data.tags', [])
          }
        })], 1) : _vm._e(), _vm.metaInfoToggles['address'] ? _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c(VTextField, {
          attrs: {
            "label": _vm.$i18n_t('Common.address'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "hide-details": "auto",
            "clearable": ""
          },
          model: {
            value: props.item.data.address.formatted_address,
            callback: function ($$v) {
              _vm.$set(props.item.data.address, "formatted_address", $$v);
            },
            expression: "props.item.data.address.formatted_address"
          }
        })], 1) : _vm._e(), _vm.metaInfoToggles['geocoordinates'] ? _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c(VTextField, {
          attrs: {
            "label": _vm.$i18n_t('Common.lat'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": _vm.ruleValidateCoordinates(props.item.coordinates.coordinates[1]),
            "hide-details": "auto",
            "clearable": ""
          },
          on: {
            "input": function ($event) {
              return _vm.formatLonLat(props.item.coordinates.coordinates, 1);
            },
            "change": function ($event) {
              return _vm.handleCoordinateChange(props.item);
            }
          },
          model: {
            value: props.item.coordinates.coordinates[1],
            callback: function ($$v) {
              _vm.$set(props.item.coordinates.coordinates, 1, $$v);
            },
            expression: "props.item.coordinates.coordinates[1]"
          }
        })], 1) : _vm._e(), _vm.metaInfoToggles['geocoordinates'] ? _c(VCol, {
          staticClass: "py-1",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c(VTextField, {
          attrs: {
            "label": _vm.$i18n_t('Common.lon'),
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": _vm.ruleValidateCoordinates(props.item.coordinates.coordinates[0]),
            "hide-details": "auto",
            "clearable": ""
          },
          on: {
            "input": function ($event) {
              return _vm.formatLonLat(props.item.coordinates.coordinates, 0);
            },
            "change": function ($event) {
              return _vm.handleCoordinateChange(props.item);
            }
          },
          model: {
            value: props.item.coordinates.coordinates[0],
            callback: function ($$v) {
              _vm.$set(props.item.coordinates.coordinates, 0, $$v);
            },
            expression: "props.item.coordinates.coordinates[0]"
          }
        })], 1) : _vm._e()], 1), _c(VRow, [_vm.metaInfoToggles['keyvalue'] ? _c(VCol, {
          staticClass: "py-1 mb-1",
          attrs: {
            "cols": "12"
          }
        }, [_c('core-dtwin-key-value-editor', {
          attrs: {
            "twinObject": props.item,
            "hasTwinEditPermission": "",
            "dense": ""
          }
        })], 1) : _vm._e()], 1), _vm.statePickerMode === 'complete' && _vm.pickableStates.length ? _c(VExpansionPanels, {
          staticClass: "my-2",
          attrs: {
            "value": null
          }
        }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
          staticClass: "text-bold mb-0"
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n              ")])]), _c(VExpansionPanelContent, [!_vm.loadingStates ? _c(VExpansionPanels, {
          staticClass: "my-2",
          attrs: {
            "value": null
          }
        }, _vm._l(_vm.pickableStates, function (state, j) {
          return _c(VExpansionPanel, {
            key: `twin-copy-${props.index}-state-${j}`
          }, [_c(VExpansionPanelHeader, [_c('p', {
            staticClass: "text-bold mb-0"
          }, [_vm._v(_vm._s(state.properties.title) + " (" + _vm._s(state.key) + ")")])]), _c(VExpansionPanelContent, [state.properties.binding && state.properties.binding.type === 'iothub' ? [_c('core-dtwin-state-iothub-edit', {
            ref: `iotBindingEdit_${props.index}_state_${j}`,
            refInFor: true,
            attrs: {
              "lclModel": props.item.states.find(s => s.id === state.id),
              "tenantId": _vm.tenantId
            },
            on: {
              "bridge-binding-changed": function ($event) {
                return _vm.stateConfigChanged(props.index, j, 'iotBindingEdit');
              }
            }
          })] : _vm._e(), state.properties.binding && state.properties.binding.type === 'iothub-aggregate' ? [_c('core-dtwin-state-iothub-aggregate-edit', {
            ref: `iotBindingEdit_${props.index}_state_${j}`,
            refInFor: true,
            attrs: {
              "lclModel": props.item.states.find(s => s.id === state.id),
              "tenantId": _vm.tenantId
            },
            on: {
              "bridge-binding-changed": function ($event) {
                return _vm.stateConfigChanged(props.index, j, 'iotBindingEdit');
              }
            }
          })] : _vm._e(), state.properties.binding && state.properties.binding.type === 'bridge' ? [_c('core-dtwin-state-bridge-edit', {
            ref: `bridgeBindingEdit_${props.index}_state_${j}`,
            refInFor: true,
            attrs: {
              "lclModel": props.item.states.find(s => s.id === state.id),
              "bridgeConfigs": _vm.bridgeConfigs
            },
            on: {
              "bridge-binding-changed": function ($event) {
                return _vm.stateConfigChanged(props.index, j, 'bridgeBindingEdit');
              }
            }
          })] : _vm._e()], 2)], 1);
        }), 1) : [_c(VSkeletonLoader, {
          staticClass: "my-2",
          attrs: {
            "type": "heading"
          }
        })]], 2)], 1)], 1) : _vm.statePickerMode === 'iothub' ? [_vm.loadingStates ? [_c(VRow, [_c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "11",
            "sm": "5",
            "md": "3"
          }
        }, [_c(VSkeletonLoader, {
          attrs: {
            "type": "heading"
          }
        })], 1), _c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "1"
          }
        }, [_c(VProgressCircular, {
          attrs: {
            "color": _vm.color,
            "width": "2",
            "indeterminate": ""
          }
        })], 1), _c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "11",
            "sm": "5",
            "md": "3"
          }
        }, [_c(VSkeletonLoader, {
          attrs: {
            "type": "heading"
          }
        })], 1), _c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "1"
          }
        }, [_c(VProgressCircular, {
          attrs: {
            "color": _vm.color,
            "width": "2",
            "indeterminate": ""
          }
        })], 1), _c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "11",
            "sm": "5",
            "md": "3"
          }
        }, [_c(VSkeletonLoader, {
          attrs: {
            "type": "heading"
          }
        })], 1), _c(VCol, {
          staticClass: "mt-2 mb-0 pb-0",
          attrs: {
            "cols": "1"
          }
        }, [_c(VProgressCircular, {
          attrs: {
            "color": _vm.color,
            "width": "2",
            "indeterminate": ""
          }
        })], 1)], 1)] : _c(VRow, _vm._l(_vm.pickableStates, function (state, j) {
          return _c(VCol, {
            key: `twin-copy-${props.index}-state-${j}`,
            staticClass: "py-1",
            attrs: {
              "cols": "12",
              "sm": "6",
              "md": "4"
            }
          }, [_c(VTextField, {
            attrs: {
              "label": `${_vm.$i18n_t('NiotaClassic.Common.table.eui')} - ${state.key}`,
              "loading": !props.item.states.find(s => s.id === state.id).properties.binding.options.identifier,
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "hint": props.item.states.find(s => s.id === state.id).deviceTitle,
              "rules": _vm.euiRules,
              "hide-details": "auto",
              "persistent-hint": "",
              "clearable": "",
              "required": ""
            },
            on: {
              "change": function ($event) {
                _vm.fetchIotHubDetails(props.item.states.find(s => s.id === state.id), props.item);
              }
            },
            model: {
              value: props.item.states.find(s => s.id === state.id).properties.binding.options.eui,
              callback: function ($$v) {
                _vm.$set(props.item.states.find(s => s.id === state.id).properties.binding.options, "eui", typeof $$v === 'string' ? $$v.trim() : $$v);
              },
              expression: "props.item.states.find((s) => s.id === state.id).properties.binding.options.eui"
            }
          })], 1);
        }), 1)] : _vm._e()], 2)];
      }
    }])
  }), _vm.statePickerMode === 'iothub' && !_vm.loadingStates ? _vm._l(_vm.twinCopiesData, function (twin, i) {
    return _c('span', {
      key: `twin-hidden-${i}`
    }, _vm._l(_vm.pickableStates, function (state, j) {
      return _c('span', {
        key: `twin-hidden-${i}-state-${j}`
      }, [_c(VInput, {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "rules": _vm.euiRules
        },
        model: {
          value: twin.states.find(s => s.id === state.id).properties.binding.options.eui,
          callback: function ($$v) {
            _vm.$set(twin.states.find(s => s.id === state.id).properties.binding.options, "eui", $$v);
          },
          expression: "twin.states.find((s) => s.id === state.id).properties.binding.options.eui"
        }
      })], 1);
    }), 0);
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };